<div class="mb-3" *ngIf="canViewAs">
    <button type="button" class="btn btn-outline-primary" (click)="viewAsUser()" [disabled]="startingView">View as user</button>
    <span class="text-muted ms-2">Read-only report view · 30 minutes · Session logged</span>
</div>
<div class="row">
    <div class="col-md-3 col-12">
        <div class="card">
            <div class="card-header">
                <div class="card-title mb-0">User</div>
            </div>
            <div class="card-body">
                <form #f="ngForm" (ngSubmit)="f.valid && submit()" novalidate>
                    <div class="mb-3">
                        <label for="name" class="form-label">Name <em>*</em></label>
                        <input type="text" class="form-control" id="name" name="name" #name="ngModel" [(ngModel)]="data.name" required autocomplete="off">
                        <div *ngIf="f.submitted && name.invalid" class="invalid-feedback">
                            <div *ngIf="name.errors.required">Name is required</div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="username" class="form-label">Login Username <em>*</em></label>
                        <input type="text" class="form-control" maxlength="12" id="username" name="username" #username="ngModel" [(ngModel)]="data.username" required autocomplete="off" [readonly]="data.uuid">
                        <div *ngIf="f.submitted && username.invalid" class="invalid-feedback">
                            <div *ngIf="username.errors.required">Username is required</div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="password" class="form-label">Login Password <em>*</em></label>
                        <input type="password" maxlength="12" class="form-control" id="password" name="password" #password="ngModel" [(ngModel)]="data.password" required autocomplete="off">
                        <div *ngIf="f.submitted && password.invalid" class="invalid-feedback">
                            <div *ngIf="password.errors.required">Password is required</div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="title" class="form-label">Status <em>*</em></label>
                        <select class="form-control" name="status" #status="ngModel" [(ngModel)]="data.status" required>
                            <option [value]="1">Active</option>
                            <option [value]="0">Disabled</option>
                        </select>
                        <div *ngIf="f.submitted && status.invalid" class="invalid-feedback">
                            <div *ngIf="status.errors.required">Status is required</div>
                        </div>
                    </div>
                    <button type="submit" class="btn btn-primary">Update</button>
                </form>
            </div>
        </div>
    </div>
    <div class="col-md-9 col-12">
        <div class="card mb-3" *ngIf="data.uuid">
            <div class="card-header fw-bold">Consolidated</div>
            <div class="card-body">
                <div class="form-check mb-2">
                    <input id="consolidated-all-branches" class="form-check-input" type="checkbox"
                        [(ngModel)]="consolidatedAccess.enabled" [disabled]="!consolidatedAccess.can_edit || savingConsolidated">
                    <label class="form-check-label" for="consolidated-all-branches">Wallet Topup/Withdraw — all assigned branches</label>
                </div>
                <p class="text-muted small">Allows Manual, Transfer and Seamless Topup/Withdraw through Consolidated for every branch assigned to this user, including future assignments. Regular branch permissions stay separate.</p>
                <button type="button" class="btn btn-primary" *ngIf="consolidatedAccess.can_edit" [disabled]="savingConsolidated" (click)="saveConsolidatedAccess()">Save Consolidated Access</button>
                <p class="text-muted small mb-0" *ngIf="!consolidatedAccess.can_edit">A Super Admin can change this permission.</p>
                <p class="mt-2 mb-0" role="status" *ngIf="consolidatedMessage">{{consolidatedMessage}}</p>
            </div>
        </div>
        <div class="card mb-3" *ngIf="data.uuid">
            <div class="card-header fw-bold">Unity Shareholder — Read Only</div>
            <div class="card-body">
                <div class="form-check mb-2">
                    <input id="unity-shareholder" type="checkbox" class="form-check-input"
                        [(ngModel)]="shareholderAccess.enabled" [disabled]="!shareholderAccess.can_edit || savingShareholder">
                    <label class="form-check-label" for="unity-shareholder">Restrict this account to Unity reports only</label>
                </div>
                <p class="text-muted small">Reports from October 2026 onward. Hides other companies and their details, and blocks editing, wallet operations and chat, even if other permissions were previously granted. The user must already be assigned to Unity.</p>
                <label for="unity-shareholder-scope">Report data</label>
                <select id="unity-shareholder-scope" class="form-select mb-2" [(ngModel)]="shareholderAccess.data_scope"
                    [disabled]="!shareholderAccess.can_edit || savingShareholder">
                    <option value="">Choose report data</option>
                    <option value="unity">Unity company only</option>
                    <option value="assigned">Combined totals of this user's assigned companies; no branch details</option>
                </select>
                <button type="button" class="btn btn-primary" *ngIf="shareholderAccess.can_edit"
                    [disabled]="savingShareholder" (click)="saveShareholderAccess()">Save Shareholder Access</button>
                <p class="mt-2 mb-0" role="status" *ngIf="shareholderMessage">{{shareholderMessage}}</p>
            </div>
        </div>
        <div class="card mb-3" *ngFor="let permission of permissionSections; let sectionIndex = index">
            <div class="card-header d-flex justify-content-between align-items-center flex-wrap gap-2">
                <div class="fw-bold mb-0">
                    {{permission.title}}
                    <span class="badge bg-secondary ms-2">{{countSelected(permission)}} / {{permission.children.length}}</span>
                </div>
                <div class="d-flex gap-2" *ngIf="permission.children.length > 0">
                    <button type="button" class="btn btn-sm btn-outline-primary" (click)="selectAll(permission)" [disabled]="countSelected(permission) === permission.children.length">
                        Select All
                    </button>
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearAll(permission)" [disabled]="countSelected(permission) === 0">
                        Clear All
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6 col-12 mb-2" *ngFor="let menu of permission.children">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="menu_{{sectionIndex}}_{{menu.id}}" name="menu_{{sectionIndex}}_{{menu.id}}" [(ngModel)]="menu.value">
                            <label class="form-check-label fs-6" for="menu_{{sectionIndex}}_{{menu.id}}">{{menu.title}}</label>
                        </div>
                    </div>
                </div>
                <p class="text-muted mb-0 small" *ngIf="permission.children.length == 0">
                    No Available Permission Found.
                </p>
            </div>
        </div>

        <div class="d-flex justify-content-end sticky-bottom py-2 bg-body" *ngIf="permissions.length > 0" style="bottom:0">
            <button type="button" class="btn btn-primary btn-lg" (click)="submit()">Save Changes</button>
        </div>
    </div>
</div>
